/* raw layout hash: _default-web-layout-2otx06:b7a7095db0020d9e9c66ec079f74db5b569d71dc81dfa74c9abfcdc32c2b49ed */
import DefaultWebShell from './components/DefaultWebShell.jsx';

/**
 * Layout `_default-web-layout-2otx06`
 * Source shell: RawHTMLDesign/layouts/_default-web-layout-2otx06.html
 *
 * A distinct layout in the design catalogue whose chrome matches
 * `_default-web-layout`. Its raw shell differs only in `<head>` composition: it
 * defers stylesheets to the page's `<!-- page import style -->` slot instead of
 * declaring font-awesome inline, and omits the extra page `<style>` block. Both
 * are Vite/SCSS concerns here, so the rendered chrome is identical — shared via
 * DefaultWebShell, while the layout keeps its own name and component.
 *
 * Pages using this layout: Workspaces & Quotas, API Credentials, Routing
 * Policies, API Job Status, Compliance & Audit (all authenticated → signed-in
 * details + log out in the navbar).
 */
export default function DefaultWebLayout2otx06({ children }) {
  return <DefaultWebShell>{children}</DefaultWebShell>;
}
